import styles from './RefundReasonStyle.css'

class ReceiptRefundReason extends React.Component {
  render () {
    let {invoiceRefund} = this.props
    return (
      <div className={styles['receipt-refund-reason']}>
        <div className='receipt-returned-goods pull-left'>
          Reason for Cancellation
        </div>
        <div className={styles['truncate-refund-reason']}>
          {invoiceRefund.refunded_reason}
        </div>
      </div>
    )
  }
}

ReceiptRefundReason.propTypes = {
  invoiceRefund: React.PropTypes.object
}

export default ReceiptRefundReason



// WEBPACK FOOTER //
// ./app/components/receipt/invoices/RefundReason/ReceiptRefundReason.js